// 案例
export const caseList=[
    {
        name:'雇主责任险',
        desc:'某企业员工在车间生产过程中，由于操作失误，造成自身受伤，治疗总共花费费用2万元，社保范围内费用为19000元。<br>社保按照社保统筹比例报销16000元后，企业仍需要给受伤员工提供4000的报销费用。由于企业事先给员工购买了雇主责任险，社保范围内统筹比例外部分可以全部报销，企业从保险公司获赔3000元。',
    },
    {
        name:'企业财产险',
        desc:'某大型企业工厂里有各种生产设备，总价值达近五千万，多年来工厂正常运营一直没有出现问题。2019年突发火灾，工厂和生产设备全部烧毁。<br>经调查，该事故因线路老化造成火源，进而造成火灾。起火原因在企业本身，本应由企业自行承担所有损失。由于该企业事先给工厂投保了财产险，保险公司根据企业提供的相关理赔材料，核实全部货物价值后，向该公司赔偿四千多万，挽回了该企业在该次事故中大部分的损失。'
    },
    {
        name:'特种设备责任险',
        desc:'某工厂员工在驾驶叉车运货时，没有注意到旁边的路人路过，致使叉车碾压路人脚部，造成脚部粉碎性骨折。伤者被马上送往医院治疗。<br>本应该工厂负责此次事故的主要责任，肇事员工负连带责任，由于工厂事先购买了特种设备责任险，保险公司承担了受伤员工的医疗费用。'
    },
    {
        name:'公众责任险',
        desc:'一考察团在某生产制造企业参观考察期间，一台生产机器发生故障，砸伤人员，伤者被紧急送往医院治疗，伤者家属向该企业提起索赔。<br>该团队人员并非该公司工人，属于第三者人员，不在雇主责任险保障范围，本应该企业全额赔偿。由于该企业购买了公众责任险，保险公司承担了此次给伤者赔偿的费用。'
    },
    {
        name:'产品责任险',
        desc:'某企业生产的产品销售到用户家里使用一年后，因产品自身质量问题发生漏电。造成用户触电身亡。该生产企业需承担赔偿责任。<br>由于该企业为所有出厂机器购买了五年的产品责任险，保险公司承担了此次赔偿损失。'
    },
    {
        name:'机器损坏险',
        desc:'某工厂生产工人在生产期间，因操作疏忽，导致机器运行故障，最终造成机器损坏。<br>本次事故本应工厂承担此次损失费用，由于事先投保了机器损坏险，保险公司赔偿机器维修所有费用。'
    },
    {
        name:'物流责任险',
        desc:'某企业的运输车队在高速路上行驶期间，因不明原因货物突然起火，因车上都是易燃物品，火势蔓延很快，顷刻间一车货物焚毁殆尽。<br>因起火原因无从查起，本应企业承担此次事故所有损失。由于该企业给每趟出车按单购买了货物运输险，保险公司勘查现场并赔偿了此次事故造成的所有损失。'
    },
    {
        name:'第三者责任保险',
        desc:'某化工工厂在生产期间，因可燃气体泄漏，遇到明火导致爆炸事件。除了企业内部损失意外，火势蔓延造成周边工厂起火。<br>本应该企业承担对其周边工厂的损失，因工厂投保了第三者责任保险，保险公司赔偿了周边工厂的损失。'
    },
    {
        name:'建工企业团体雇主责任险',
        desc:'保障项目施工过程中工人因意外事故造成的人身伤亡，相应赔付责任由总包方/分包方承担，该保险可按照项目采取不记名形式购买。或者按照实名制为施工人员购买，保额从50万-100万可供选择，理赔不需要安检证明，无人员限制，费率低于行业50%，被保险人为企业，最大限度保障企业损失。'
    },
    {
        name:'建设工程一切险及第三者责任险',
        desc:'案例一：某在建工程施工过程中突发地震造成在建工程发生坍塌，财产损失严重，若项目购买建工一切险，相应损失由保险公司承担。<br>案例二：某施工项目施工过程中因管理不善，造成建筑材料高空掉落，砸坏邻近第三方房屋，并有三名路人受伤，损失总额共计300万，因购买建工一切及三者责任保险，且三者部分保额高达3000万，故保险公司承担相应赔偿责任'
    },
    {
        name:'种植农业险',
        desc:'某地区一直以种植小麦为当地主要产业，夏季该地区突然爆发洪涝灾害，大规模小麦种植区被淹，小麦减产异常严重。<br>该地种植户在此次洪涝灾害中蒙受了巨大损失，但因其一直投保种植农业险，保险公司承担了此次洪涝造成损失的主要责任，挽回了农户在此次事故中大部分损失。'
    },
    {
        name:'养殖农业险',
        desc:'某地区一直以鸡养殖为当地主要产业，某年该地区突然爆发鸡瘟，养殖的鸡鸭大规模死亡。<br>农户在此次事故中损失严重。但因其一直投保养殖农业险，保险公司承担了此次鸡瘟造成损失的主要责任，挽回了农户在此次事故中大部分损失。'
    },
    {
        name:'医疗责任保险',
        desc:'某医院医生在在给一名重病患者做手术期间，由于操作失误，造成患者死亡 ，死者家属向医院进行索赔。<br>本应由医院承担此次事故损失，由于医院投保了医疗责任险，保险公司依法对死者家属进行赔偿。'
    },
    {
        name:'重大疾病保险',
        desc:'五年前张先生身体健康，在保险公司为自己投保了重大疾病保险，五年后张先生在医院检查出了胃癌，向保险公司提交理赔材料后，一次性获得赔款3万元。'
    },
    {
        name:'百万医疗保险',
        desc:'张先生最近得了肺炎，到医院治疗总共花费了10万元，由于张先生每年购买百万医疗保险，张先生从保险公司获赔9万元。'
    },
]
// 保险产品
export const products=[
    {
        img:'/static/images/scheme/product_1.jpg',
        name:'企业团体雇主责任险',
        desc:'保障企业员工因工作原因造成人身伤亡，相应责任应由企业承担的，保险公司负责赔偿',
        url:'/haierProduct.html#/company-group-employer'
    },
    {
        img:'/static/images/scheme/product_2.jpg',
        name:'企业财产险',
        desc:'保障企业固定资产及存货因自然灾害和意外事故等原因造成的财产损失'
    },
    {
        img:'/static/images/scheme/product_3.jpg',
        name:'特种设备责任险',
        desc:'保障企业特种设备（叉车、夹包机、电梯等）在操作过程中造成的财产及人身伤害损失'
    },
    {
        img:'/static/images/scheme/product_4.jpg',
        name:'公众责任险',
        desc:'保障企业生产过程中园区内给第三方造成的财产及人身伤害损失'
    },
    {
        img:'/static/images/scheme/product_5.jpg',
        name:'机器损坏险',
        desc:'机器在运行过程中因人为的、意外的或物理原因造成突然发生的、不可预见的机器设备损失'
    },
    {
        img:'/static/images/scheme/product_6.jpg',
        name:'企业团体福利保险',
        class:'fz16',
        desc:'为企业定制员工福利性的保险方案，组合重大疾病险、寿险、意外伤害、医疗险等 最大限度减轻疾病和意外等给员工工作、生活带来的冲击，彻底解决员工后顾之忧，同时提升企业口碑和形象，增加员工归属感'
    },
    {
        img:'/static/images/scheme/product_7.jpg',
        name:'产品责任险',
        desc:'企业生产的产品因存在缺陷，造成使用、消费该产品的人或第三者的人身伤害、疾病、死亡或财产损失'
    },
    {
        img:'/static/images/scheme/product_8.jpg',
        name:'物流责任险',
        desc:'保障企业在运输货物的过程中因意外事故造成的财产损失'
    },
    {
        img:'/static/images/scheme/product_9.jpg',
        name:'第三者责任保险',
        class:'fz16',
        desc:'保障被保险人合法聘用的工作人员在被保险人的工作场所内，受雇从事保险单明细表所载明的被保险人的业务过程中，发生安全生产事故，造成第三者死亡，依法应由被保险人承担的经济赔偿损失'
    },
    {
        img:'/static/images/scheme/product_10.jpg',
        name:'建工企业团体雇主责任险',
        desc:'保障建设施工项目（土建、装修）等企业员工因工伤亡，相应责任应由企业承担的，保险公司负责赔偿，可以按照项目或者实名制购买。'
    },
    {
        img:'/static/images/scheme/product_11.jpg',
        name:'建筑工程一切险及第三者责任险',
        class:'fz16',
        desc:'保障在建工程因自然灾害设计失误等造成在建工程及设备本身的财产损失，同时保障因施工过程中给第三者造成的财产或人身损失'
    },
    {
        img:'/static/images/scheme/product_12.jpg',
        name:'合同款支付/履约保证保险',
        class:'fz16',
        desc:'合同款支付保证保险：保障按照合同约定发包方按约支付相应费用，发生违约由保险公司赔付相应工程款履约保证保险：保障施工方按期按质完工，保障对象为发包方'
    },
    {
        img:'/static/images/scheme/product_13.jpg',
        name:'投保保证金保险/农民工工资支付保险',
        class:'fz16',
        desc:'投保保证金保险：通过购买保险形式替代向发包方缴纳保证金与银行保函同等效力农民工支付保证保险：投保人未按建设工程施工合同约定向施工单位结清工程款或违法发包导致被保险人被拖欠工资，按照保险约定承担赔偿责任'
    },
    {
        img:'/static/images/scheme/product_14.jpg',
        name:'种植农业险',
        desc:'保障农作物或者林木，在生长过程中发生约定的灾害事故造成的经济损'
    },
    {
        img:'/static/images/scheme/product_15.jpg',
        name:'养殖农业险',
        desc:'保障牲畜、家禽、水产在生长过程中发生约定的灾害事故造成的经济损失'
    },
    {
        img:'/static/images/scheme/product_16.jpg',
        name:'医疗责任险',
        desc:'医疗机构和医务人员在保险期内，因医疗责任发生经济赔偿或法律费用，保险公司将依照事先约定承担赔偿责任。'
    },
    {
        img:'/static/images/scheme/product_17.jpg',
        name:'重大疾病保险',
        class:'fz16',
        desc:'由保险公司经办的以特定重大疾病，如恶性肿瘤、心肌梗死、脑溢血等为风险发生时，当被保人达到保险条款所约定的重大疾病状态后，由保险公司根据保险合同约定支付保险金。'
    },
    {
        img:'/static/images/scheme/product_18.jpg',
        name:'百万医疗保险',
        desc:'保障被保险人因意外、疾病、恶心肿瘤等住院医疗，扣除1万免赔后，100%报销。'
    },
]


// WEBPACK FOOTER //
// ./src/pages/scheme/components/common/dictionary.js